import { TAttendeeLimit, TMeetingRoom } from "apis/meetings/meeting-room";

export enum ErrorType {
  TIME,
  ATTENDEE_NUM,
}

export interface MinimumAttendeesSettingModalProps {
  modalIsOpen: boolean; //* INFO: 모달 오픈 여부
  closeModal: () => void; //* INFO: 모달 닫기 함수
  onUpdate?: (attendeeLimits: TAttendeeLimit[]) => void; //* INFO: 회의실 리스트 업데이트 함수
  room: TMeetingRoom; //* INFO: 수정할 회의실 정보
}
